import React, { useRef, useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchRefunds } from "../util/fetchUserUtil";
import RefundActionIcon from "../assets/refund-action.svg";

const RefundsTable = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchRefunds(postData);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  return (
    <ReusableTable
      key={"telecom_refunds"}
      tableType={"refunds"}
      tableName={"Refunds"}
      needGlobalFilter={true}
      needPagination={true}
      onStateChange={fetchData}
      isExtendingReusableColumns={false}
    />
  );
};

export default RefundsTable;
